import React from "react";
import { useSupplyReportStore } from "../../stores/supplyReportStore";

// Компонент для вибору джерела
const SupplyReportFilterPanel = React.memo(() => {
  const currentFilterPageId = useSupplyReportStore(
    (state) => state.filters.filter_page,
  );
  const filterPages = useSupplyReportStore((state) => state.filterPages);
  const setFilterPage = useSupplyReportStore((state) => state.setFilterPage);

  // Масив джерел з вибором "Всі джерела"
  const options = [{ id: null, name: "Всі джерела" }, ...filterPages];

  return (
    <div className="tables-pick-panel">
      {options.map((option) => (
        <button
          key={option.id === null ? "all" : option.id}
          className={`focus-button ${currentFilterPageId === option.id ? "active" : ""}`}
          onClick={() => setFilterPage(option.id)}
        >
          <div className="check"></div>
          {option.name}
        </button>
      ))}
    </div>
  );
});

export default SupplyReportFilterPanel;
